export default "__VITE_PUBLIC_ASSET__6a514050__"